import { lazy } from "react";
// Note: make sure path is in lower case

export const routes = {
  billing: {
    path: "/billing/:tab?/:subtab?",
    element: lazy(() => import("../../pages/Billing")),
  },
  changeFacility: {
    path: "/change-facility",
    element: lazy(() => import("../../pages/ChangeFacility")),
  },
  vitalSync: {
    path: "/vitals-ai",
    element: lazy(() => import("../../pages/VitalSync")),
  },
  vitalSyncHistory: {
    path: "/vitals-ai/history",
    element: lazy(
      () => import("../../pages/VitalSync/PCCSubmissionHistoryPage")
    ),
  },
  search: {
    path: "/search",
    element: lazy(() => import("../../pages/Search")),
  },
  clinical: {
    path: "/clinical",
    element: lazy(() => import("../../pages/CareCoordination")),
  },
  trends: {
    path: "/trends",
    element: lazy(() => import("../../pages/Trends")),
  },
  patientProfile: {
    path: "/patient-profile/:patientId",
    element: lazy(() => import("../../pages/PatientProfile")),
  },

  SBARReportPage: {
    path: "/sbar-report/:patientId/:reportId",
    element: lazy(() => import("../../pages/SBARReportPage")),
  },
  addBedExitAlert: {
    path: "/manage-alert/:residentId/add",
    element: lazy(() => import("../../pages/EditBedExitAlerts")),
  },
  exitBedExitAlert: {
    path: "/manage-alert/:patientId/edit",
    element: lazy(() => import("../../pages/EditManageBedExitAlert")),
  },
  patientProfileFacility: {
    path: "/patient-profile/:patientId/clinic/:clinicId",
    element: lazy(() => import("../../pages/PatientProfile")),
  },
  patientProfileForRedirect: {
    path: "/patient-profile/:patientId/:slug1/:slug2/:slug3",
    element: lazy(() => import("../../pages/PatientProfile")),
  },
  changePassword: {
    path: "/change-password",
    element: lazy(() => import("../../pages/ChangePassword")),
  },
  changePin: {
    path: "/change-pin",
    element: lazy(() => import("../../pages/ChangePin")),
  },
  watchlist: {
    path: "/watchlist",
    element: lazy(() => import("../../pages/Watchlist")),
  },
  reports: {
    path: "/reports",
    element: lazy(() => import("../../pages/Reports")),
  },
  bedexits: {
    path: "/bedexits",
    element: lazy(() => import("../../pages/BedExitEvents")),
  },
  riskReport: {
    path: "/risk-report",
    element: lazy(() => import("../../pages/Reports/AIRiskReportPage")),
  },
  riskReport2: {
    path: "/public/risk-report",
    element: lazy(() => import("../../pages/Reports/AIRiskReportPage")),
  },
  dailyReport: {
    path: `/daily-report/:dailyReportId`,
    element: lazy(() => import("../../pages/Reports/DailyReport")),
  },
  myFacility: {
    path: "/my-facility",
    element: lazy(() => import("../../pages/MyFacility")),
  },
  eSignReview: {
    path: "/my-facility/review/:consentStatus/:residentId",
    element: lazy(() => import("../../pages/MyFacility/ConsentESignReview")),
  },
  eSignForm: {
    path: "/my-facility/form/:consentStatus/:residentId",
    element: lazy(() => import("../../pages/MyFacility/ConsentESignForm")),
  },
  alertDetails: {
    path: "/alert-details/:alertId/:residentId",
    element: lazy(() => import("../../pages/CareCoordination/AlertDetails")),
  },

  alertDetailHash: {
    path: "#/alert-details/:alertId/:residentId",
    element: lazy(() => import("../../pages/CareCoordination/AlertDetails")),
  },
  contactSupport: {
    path: "/contact-support",
    element: lazy(() => import("../../pages/ContactSupport")),
  },

  intendedUse: {
    path: "/intended-use",
    element: lazy(() => import("../../pages/IntendedUser")),
  },

  faq: {
    path: "/faq",
    element: lazy(() => import("../../pages/Faq")),
  },

  feedback: {
    path: "/feedback",
    element: lazy(() => import("../../pages/Feedback")),
  },
  floorSettings: {
    path: "/floor-settings",
    element: lazy(() => import("../../pages/FloorSettings")),
  },
  notificationSettings: {
    path: "/notification-settings",
    element: lazy(() => import("../../pages/NotificationSettings")),
  },
  reportAProblem: {
    path: "/reportAProblem",
    element: lazy(() => import("../../pages/ReportAProblem")),
  },
  rateApp: {
    path: "/rateApp",
    element: lazy(() => import("../../pages/RateApp")),
  },
  privacyPolicy: {
    path: "/privacyPolicy",
    element: lazy(() => import("../../pages/PrivacyPolicy")),
  },
  dashboard: {
    path: "/dashboard",
    element: lazy(() => import("../../pages/Dashboard")),
  },
  settings: {
    path: "/settings",
    element: lazy(() => import("../../pages/Settings")),
  },
  bedExitPatientChart: {
    path: "/bed-exit/patient/:patientId/clinic/:clinicId",
    element: lazy(() => import("../../pages/PatientProfile")),
  },
  // bedExitAlert: {
  //   path: "bedexit-alerts",
  //   element: lazy(() => import("../../pages/BedExitAlerts")),
  // },
  editBedExitAlert: {
    path: "/edit-bed-exit-alerts/:residentId",
    element: lazy(() => import("../../pages/EditBedExitAlerts")),
  },
  editBedExitAlertForSettings: {
    path: "/bed-exit-settings",
    element: lazy(() => import("../../pages/EditBedExitAlertsForSettings")),
  },
  alertChimeScreen: {
    path: "/bed-exit/chime/:residentId/:roomName/:clinicId/:sound",
    element: lazy(() => import("../../pages/AlertChime")),
  },
  escalationChimeScreen: {
    path: "/escalation/chime/:residentId/:roomName/:clinicId/:sound/:escalationId",
    element: lazy(() => import("../../pages/EscalationChime")),
  },
  flagChimeScreen: {
    path: "/flag/chime/:residentId/:roomName/:clinicId/:sound/:psnFlagId",
    element: lazy(() => import("../../pages/FlagChime")),
  },
  SummaryScreen: {
    path: "/summary",
    element: lazy(() => import("../../pages/SummaryScreen")),
  },
  IPVNoteScreen: {
    path: "/ipv",
    element: lazy(() => import("../../pages/IPVNote")),
  },
  Insights: {
    path: "/insights",
    element: lazy(() => import("../../pages/Insights")),
  },
  motionAndExits: {
    path: "/motion-and-exits",
    element: lazy(() => import("../../pages/BedExitEvents")),
  },
  intercom: {
    path: "/intercom",
    element: lazy(() => import("../../pages/Features/IntercomPage")),
  },
  iq: {
    path: "/iq",
    element: lazy(() => import("../../pages/Features/IQPage")),
  },
  intake: {
    path: "/intake",
    element: lazy(() => import("../../pages/Features/IntakePage")),
  },
  mds: {
    path: "/mds",
    element: lazy(() => import("../../pages/Features/MDSPage")),
  },
  medRecAI: {
    path: "/medications",
    element: lazy(() => import("../../pages/MedRecAI")),
  },
  rtBilling: {
    path: "/rt/billing",
    element: lazy(() => import("../../pages/RTBilling")),
  },
  rtBillingCycle: {
    path: "/rt/billing/cycle",
    element: lazy(() => import("../../pages/RTBillingCycle")),
  },
  voice: {
    path: "/voice",
    element: lazy(() => import("../../pages/Features/VoicePage")),
  },
  userInfo: {
    path: "/user-info",
    element: lazy(() => import("../../pages/UserInfo")),
  },
  newVisit: {
    path: "/visits/new",
    element: lazy(() => import("../../pages/Visits/NewVisit")),
  },
  visitNotes: {
    path: "/visit-notes",
    element: lazy(() => import("../../pages/Visits")),
  },
  visitNote: {
    path: "/visit-notes/note/:noteId",
    element: lazy(() => import("../../pages/Visits/VisitNotePage")),
  },
  visitCalendar: {
    path: "/visit-notes/calendar",
    element: lazy(() => import("../../pages/Visits/VisitsCalendar")),
  },
  logout: {
    path: "/logout",
    element: lazy(() => import("../../pages/LogoutPage")),
  },
  // ⛔️ADD MORE ROUTE ABOVE THIS LINE⛔️
  redirectElementStar: {
    path: "*",
    element: lazy(() => import("./redirectElement")),
  },
  redirectElement: {
    path: "",
    element: lazy(() => import("./redirectElement")),
  },
  termsOfUse: {
    path: "/terms-of-use",
    element: lazy(() => import("../../pages/TermsOfUse")),
  },
  evaluationAndManagement: {
    path: "/navigator",
    element: lazy(() => import("../../pages/Navigator")),
  },
} as const;
